import { useEffect, useState } from 'react'
import { api } from '../api/client'
import type { Me } from '../api/types'

// L'identità non cambia durante la sessione: si legge una volta e la condividono tutte le
// schermate. Il modulo fa da cache perché un contesto React sarebbe cerimonia in più per un
// dato che non ha bisogno di aggiornarsi.
let cached: Me | undefined
let inFlight: Promise<Me> | undefined

function fetchMe(): Promise<Me> {
  inFlight ??= api.get<Me>('/me').finally(() => {
    inFlight = undefined
  })
  return inFlight
}

/**
 * Chi sta usando l'applicazione e cosa può fare. `me` resta indefinito finché la risposta
 * non arriva: chi nasconde un comando dietro un permesso deve trattare «non so ancora» come
 * «non mostrare», non come «vietato per sempre».
 */
export function useMe(): { me?: Me; hasPermission: (p: string) => boolean } {
  const [me, setMe] = useState<Me | undefined>(cached)

  useEffect(() => {
    if (cached) return
    let cancelled = false
    fetchMe()
      .then((data) => {
        cached = data
        if (!cancelled) setMe(data)
      })
      .catch(() => {
        /* senza /me si resta senza permessi: i comandi protetti non compaiono */
      })
    return () => {
      cancelled = true
    }
  }, [])

  return { me, hasPermission: (p) => me?.permissions.includes(p) ?? false }
}
